import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CdkStep, CdkStepper } from '@angular/cdk/stepper';
import { IconNames } from '@app/shared/enums/icon-names';
import { IceButtonComponent } from '../../atoms/ice-button/ice-button.component';
import { MatIcon } from '@angular/material/icon';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-ice-stepper',
  templateUrl: './ice-stepper.component.html',
  styleUrls: ['./ice-stepper.component.scss'],
  providers: [{ provide: CdkStepper, useExisting: IceStepperComponent }],
  imports: [NgClass, MatIcon, NgTemplateOutlet, IceButtonComponent],
})
export class IceStepperComponent extends CdkStepper {
  IconNames = IconNames;

  @Input({ required: true }) interactedSteps: number[];
  @Input() currentStepLabel: string;
  @Input() hasCustomNavigation = true;
  @Input() isCancelable = false;
  @Input() hasVisualFinalStep = true;

  @Output() isFinished = new EventEmitter<boolean>(false);
  @Output() cancelStepper = new EventEmitter();

  onStepChange(index: number): void {
    this.selectedIndex = index;
  }

  isCurrentStep(index: number): boolean {
    return this.selectedIndex === index;
  }

  isStepCompleted(step: CdkStep, index: number): boolean {
    return step.completed && this.interactedSteps.includes(index);
  }

  isStepError(step: CdkStep, index: number): boolean {
    return step.hasError && this.interactedSteps.includes(index);
  }
}
